import { API_URL } from '../api/client';

const Help = (): React.JSX.Element => {
   const docs_url = API_URL + '/docs';
   const redoc_url = API_URL + '/redoc';

   return (
      <article className="md-content__inner md-typeset">
         <h1 id="installation">Documentation</h1>
         <h2>AHoJ Methodology</h2>
         <p>
            1. The user specifies a Point of Interest (POI) in the form of a ligand, ligand-binding residue, or
            post-translationally modified residue in the query structure.
            <br />
            2. AHoJ selects the ligand(s) either directly (if the user explicitly defined the index), or by applying a
            distance threshold from the specified binding residue.
            <br />
            3. The protein binding residues (pocket) for the selected ligand are detected by applying a distance
            threshold.
            <br />
            4. The protein binding residues are mapped onto the UniProt sequence that the protein chain belongs to.
            <br />
            5. The available structures in the Protein Data Bank (PDB) that feature a minimum percentage of the mapped
            binding residues (MBRs) in their SEQRES are collected as candidate structures.
            <br />
            6. The query binding residues are mapped (through UniProt) onto all other candidate structures, and the
            query binding site (pocket) is reconstructed in each candidate structure.
            <br />
            7. The MBRs in the candidate structures are checked for bound ligands & metrics are collected to measure the
            similarity between the query pocket and each candidate pocket (chain RMSD, pocket residue RMSD, SASA, etc.).
            <br />
            8. Depending on the presence or absence of ligands (and considering the user settings), the candidate
            pockets are annotated as holo or apo, in reference to the particular query pocket.
            <br />
         </p>
         <h2 id="rest-api">REST API</h2>
         Most of the functionality of AHoJ and AHoJ-DB is accessible via REST API.
         <br />
         Note: API is still in Beta stage. If you are using REST API please let us know.
         <h3>REST API Documentation</h3>
         <p>
            Interactive REST API browser is available <a href={docs_url}> here</a> or alternatively
            <a href={redoc_url}> here (redoc)</a>.
         </p>
         <br />
         <br />
         <br />
      </article>
   );
};

export default Help;
